import React from 'react';
import { Dialog } from './common/Dialog';
import { Button } from './common/Button';
import * as styles from '../styles/components/warning-dialog.css.ts';

interface WarningDialogProps {
  warnings: string[];
  title: string;
  onClose: () => void;
  onContinue: () => void;
}

/**
 * 警告メッセージを表示するダイアログコンポーネント
 */
export const WarningDialog: React.FC<WarningDialogProps> = ({
  warnings,
  title,
  onClose,
  onContinue
}) => {
  return (
    <Dialog
      isOpen={true}
      onClose={onClose}
      title={title}
      width="md"
      footer={
        <Button variant="primary" onClick={onContinue}>
          Continue
        </Button>
      }
    >
      <div>
          <div className={styles.warningIcon}>
            ⚠️
          </div>
          
          <p className={styles.message}>
            Data loading completed with warnings. The data has been successfully imported, 
            but you may want to review these warnings:
          </p>
          
          <div className={styles.warningList}>
            {warnings.map((warning, index) => (
              <div key={index} className={styles.warningItem}>
                <span className={styles.warningBullet}>•</span>
                <span className={styles.warningText}>{warning}</span>
              </div>
            ))}
          </div>
          
          <div className={styles.note}>
            <strong>Note:</strong> These warnings do not affect the functionality
            and can usually be safely ignored. The data import was successful.
          </div>
      </div>
    </Dialog>
  );
};
